var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTruckGo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 9.492,
    viewBox: "0 0 18 9.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_truck_go",
    d: "M18,0H5.273V1.055H1.591L0,4.634v3.8H2.2a1.582,1.582,0,0,0,2.983,0h6.58a1.581,1.581,0,0,0,2.546.651,1.581,1.581,0,1,0,1.97-2.467H18ZM1.339,4.219l.938-2.109H3.516V4.219ZM3.691,8.438a.527.527,0,1,1,.527-.527.528.528,0,0,1-.527.527m7.98-1.055H6.328V6.621h5.344Zm-.241-3.5v.724L9.743,3.164l1.688-1.447v.724H13.6V3.888Zm1.823,4.55a.527.527,0,1,1,.527-.527.528.528,0,0,1-.527.527m2.109,0a.527.527,0,1,1,.527-.527.528.528,0,0,1-.527.527",
    fill: "#0045d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTruckGo);
export default __webpack_public_path__ + "static/media/icon_truck_go.53f1f813a811c7e22c40afc5dddf6d5d.svg";
export { ForwardRef as ReactComponent };